import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import { IconButton, TableCell, TableRow } from "@mui/material";
import React from "react";

import { WORKFLOW_ELEMENT_ID_OPTIONS } from "@/components/screens/WorkflowFormPage/constants";
import useGetWorkflowEngineById from "@/hooks/requests/workflowEngine/use-get-workflow-engine-backoffice-by-id";
import { IWorkflowStep, StepType } from "@/interfaces/workflow-step.interface";
import { WorkflowEditDialogMessages } from "@/messages/workflow/workflow-edit-dialog.messages";

interface WorkflowStepTableRowProps {
  step: IWorkflowStep;
  /** Calculado pela mesma regra do delete: se outro step aponta para este (goto ou exceção) */
  inUse?: boolean;
  maxCharsToShow?: number;
  messages: WorkflowEditDialogMessages;
  onOpenPopover: (
    event: React.MouseEvent<HTMLButtonElement, MouseEvent>,
    step: IWorkflowStep
  ) => void;
  isAdmin?: boolean;
  onRemove?: (step: IWorkflowStep) => void;
  isLoadingPopover?: boolean;
}

export function WorkflowStepTableRow({
  step,
  inUse,
  messages,
  onOpenPopover,
}: WorkflowStepTableRowProps) {
  const { stepTypeSOption, stepTypeDOption } = messages;

  const { data: engine } = useGetWorkflowEngineById({
    _id: step.workflowEngineId || 0,
  });

  const elementOptions = WORKFLOW_ELEMENT_ID_OPTIONS();
  const rawElementLabel =
    elementOptions.find((o) => o.value === (step.workflowElementId ?? 0))?.label ?? "-";
  /** Só o nome do elemento, sem o prefixo "N - " (ex.: "4 - Process" → "Process") */
  const elementLabel = rawElementLabel.replace(/^\d+\s*-\s*/, "");

  const defaultStepTypeText = "-";
  const stepTypeToText = {
    [StepType.StepTypeS]: stepTypeSOption,
    [StepType.StepTypeD]: stepTypeDOption,
  };
  const stepTypeText = step.stepType ? stepTypeToText[step.stepType] : defaultStepTypeText;

  return (
    <TableRow>
      <TableCell>{step.stepNumber}</TableCell>
      <TableCell>{step.stepName ?? "-"}</TableCell>
      <TableCell>{elementLabel}</TableCell>
      <TableCell>{stepTypeText}</TableCell>
      <TableCell>{engine?.name ?? "-"}</TableCell>
      <TableCell>{step.exceptionSourceWorkflowStepName ?? "-"}</TableCell>
      <TableCell>{step.gotoWorkflowStepName ?? "-"}</TableCell>
      <TableCell>{inUse === true ? "Sim" : "Não"}</TableCell>
      <TableCell>{step.chatTransferAllowed ? "Sim" : "Não"}</TableCell>
      <TableCell>
        <IconButton
          onClick={(e) => {
            e.stopPropagation();
            onOpenPopover(e, step);
          }}
        >
          <MoreHorizIcon />
        </IconButton>
      </TableCell>
    </TableRow>
  );
}
